<template>
  <v-select v-bind="$props" v-on="$listeners" class="rounded-lg">
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-select>
</template>

<script>
import { VSelect } from "vuetify/lib"

export default {
  extends: VSelect,

  props: {
    solo: { default: true },
    dense: { default: true },
    "hide-details": { default: true },
  },
}
</script>
